import { FileRequestParams, FilePatchRequestBody, DocumentSearchResponse } from '@lio/api-types';
import { documentQueryKey } from '@services/document';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { omit } from 'lodash';

export const useUpdateFile = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const result = useMutation({
    mutationFn: (body: FileRequestParams & FilePatchRequestBody) =>
      client.patch(`file/${body.fileId}`, {
        json: {
          ...omit(body, ['fileId']),
        },
      }),
    onSuccess: (_, variables) => {
      queryClient.setQueriesData<DocumentSearchResponse>({ queryKey: documentQueryKey.search }, (oldData) => {
        if (oldData?.items) {
          const newItems = oldData.items.map((document) => {
            if (document.file?.id === variables.fileId) {
              return {
                ...document,
                file: {
                  ...document.file,
                  ...omit(variables, ['fileId']),
                },
              };
            }
            return document;
          });
          return {
            ...oldData,
            items: newItems,
          };
        }
        return oldData;
      });
    },
  });
  return { ...result, updateFileAsync: result.mutateAsync };
};
